<!-- 套餐列表 -->
<template>
  <div class="main">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="projectName" suffix-icon="el-icon-search" placeholder="搜索项目套餐名称" clearable @change="onSearch"></el-input>
      <el-button type="primary" @click="onAdd">新增</el-button>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="urlList" label="图片">
          <template slot-scope="scope">
            <span class="show_img" @click="previewImage(scope.row.urlList)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column min-width="200" show-overflow-tooltip prop="packageName" label="项目套餐名称"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="number" label="项目数量"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="originalPrice" label="原价（元）"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="discountPrice" label="套餐价（元）"></el-table-column>
        <el-table-column label="状态" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="#" inactive-color="#E2E2E2" @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="230px" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" plain @click="handelDele(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      projectName: "",
      // 图片预览
      showViewer: false,
      imgList: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      tableData: [],
    }
  },
  created() {
    this.selectEnterpriseInfoList()
  },
  methods: {
    // 切换上下架
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`确定${row.switch ? "上架" : "下架"}该项目套餐吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.packageStatus, {
              packageIdList: [row.id],
              saleStatus: row.switch ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success(res.desc)
              this.selectEnterpriseInfoList()
            })
            .catch(err => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error(err.desc)
              this.selectEnterpriseInfoList()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.selectEnterpriseInfoList()
        })
    },
    handleEdit(row) {
      this.$router.push({
        path: "/formalProject/detail/modifyMenu",
        query: {
          id: row.id,
        },
      })
    },
    // 删除
    handelDele(row) {
      this.$confirm("此操作将永久删除该项目套餐, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .get(this.$api.deleteProjectPackage, {
              params: {
                id: row.id,
              },
            })
            .then(res => {
              this.$message({
                type: "success",
                message: res.desc,
              })
              this.selectEnterpriseInfoList()
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.desc,
              })
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    // 获取列表
    selectEnterpriseInfoList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        auditStatus: this.auditStatus || null,
        packageName: this.projectName || null, //套餐名称
        passStatus: 1,
      }
      this.$axios
        .post(this.$api.selectProjectPackageList, params)
        .then(res => {
          if (res.code == 100) {
            let list = res.result.list.map(e => {
              return {
                ...e,
                switch: e.saleStatus == 1 ? true : false,
              }
            })
            this.tableData = list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    // 新增
    onAdd() {
      this.$router.push({
        path: "/formalProject/detail/addSetMenu",
      })
    },
    onSearch() {
      this.clearData()
      this.selectEnterpriseInfoList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectEnterpriseInfoList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectEnterpriseInfoList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList = url || []
      this.showViewer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.show_img {
  color: #1777d8;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
}
</style>
